/** Nomes canónicos do pipeline de anamnese (hierarquia documentada em docs/internal). */
export const ANAMNESIS_PIPELINE_SPANS = {
  ROOT: 'anamnesis_consultation',
  AUDIO_CHUNK_RECEIVED: 'audio_chunk_received',
  AUDIO_UPLOAD: 'audio_upload',
  STT_PROCESSING: 'stt_processing',
  DIARIZATION_PROCESSING: 'diarization_processing',
  SPEAKER_IDENTIFICATION: 'speaker_identification',
  AI_ANALYSIS: 'ai_analysis',
  INSIGHT_GENERATION: 'insight_generation',
  UI_DELIVERY: 'ui_delivery',
  FINAL_SUMMARY_GENERATION: 'final_summary_generation',
} as const

export type AnamnesisPipelineSpanName =
  (typeof ANAMNESIS_PIPELINE_SPANS)[keyof typeof ANAMNESIS_PIPELINE_SPANS]

/** Mapeia eventos Sentry técnicos existentes → span Langfuse (sem duplicar lógica de negócio). */
export const TECHNICAL_EVENT_TO_PIPELINE_SPAN: Partial<
  Record<string, AnamnesisPipelineSpanName>
> = {
  transcription_chunk_confirmed: ANAMNESIS_PIPELINE_SPANS.AUDIO_CHUNK_RECEIVED,
  external_whisper_upstream: ANAMNESIS_PIPELINE_SPANS.STT_PROCESSING,
  speaker_classified: ANAMNESIS_PIPELINE_SPANS.SPEAKER_IDENTIFICATION,
  speaker_low_confidence: ANAMNESIS_PIPELINE_SPANS.SPEAKER_IDENTIFICATION,
  diarization_failed: ANAMNESIS_PIPELINE_SPANS.DIARIZATION_PROCESSING,
  speaker_verification_failed: ANAMNESIS_PIPELINE_SPANS.SPEAKER_IDENTIFICATION,
  ai_insight_requested: ANAMNESIS_PIPELINE_SPANS.AI_ANALYSIS,
  ai_insight_completed: ANAMNESIS_PIPELINE_SPANS.INSIGHT_GENERATION,
  ai_insight_failed: ANAMNESIS_PIPELINE_SPANS.INSIGHT_GENERATION,
  final_summary_requested: ANAMNESIS_PIPELINE_SPANS.FINAL_SUMMARY_GENERATION,
  final_summary_completed: ANAMNESIS_PIPELINE_SPANS.FINAL_SUMMARY_GENERATION,
  final_summary_failed: ANAMNESIS_PIPELINE_SPANS.FINAL_SUMMARY_GENERATION,
  streaming_restart: ANAMNESIS_PIPELINE_SPANS.AUDIO_CHUNK_RECEIVED,
  transcription_fallback_used: ANAMNESIS_PIPELINE_SPANS.STT_PROCESSING,
  transcription_engine_switched: ANAMNESIS_PIPELINE_SPANS.STT_PROCESSING,
}
